import React, { useState, useEffect, useRef } from "react";
import { useLocation, Link } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";
import Logofrance from "../assets/images/Logos/france-flag-png-large 1.png";
import Logomada from "../assets/images/Logos/Flag_of_Madagascar.svg 1.png";
import Logo from "../assets/images/Logos/logo.svg";
import ScrollToTop from "./ScrollToTop";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [showLangMenu, setShowLangMenu] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/" || location.pathname === "/home";
  const menuRef = useRef(null);
  const langMenuRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
      if (langMenuRef.current && !langMenuRef.current.contains(event.target)) {
        setShowLangMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const navItems = isHome
    ? [
        { name: "Accueil", to: "acceuil" },
        { name: "A propos", to: "pub" },
        { name: "Parcours proposés", to: "book" },
        { name: "Ressources pédagogiques", to: "category" },
      ]
    : [
        { name: "Accueil", to: "/" },
        { name: "Parcours proposés", to: "/livres" },
      ];

  const languages = [
    { name: "Français", flag: Logofrance, code: "fr" },
    { name: "Malagasy", flag: Logomada, code: "mg" },
  ];

  return (
    <header
      className={`fixed w-full top-0 z-50 transition-all duration-300 mb-4
            ${
              scrolled ? "bg-white shadow-lg" : "bg-white/80 backdrop-blur-md"
            }`}
    >
      <div className="container mx-auto px-4 lg:px-[10%]">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0">
            <div className="flex text-center items-center">
              <h1 className="text-3xl font-bold">
                <span className="text-red-600">Tis</span>
                <span className="text-gray-800">radar</span>
              </h1>
            </div>
          </Link>

          {/* Navigation principale - Desktop */}
          <nav className="hidden md:flex space-x-1">
            {navItems.map((item) =>
              isHome ? (
                <ScrollLink
                  key={item.to}
                  to={item.to}
                  spy={true}
                  smooth={true}
                  duration={500}
                  activeClass="text-red-600"
                  className="px-4 py-2 text-sm font-medium text-gray-700 rounded-lg
                                             transition-all duration-300 hover:bg-gray-100 hover:text-red-600
                                             relative after:absolute after:bottom-0 after:left-0 after:w-full
                                             after:h-0.5 after:bg-red-600 after:scale-x-0 hover:after:scale-x-100
                                             after:transition-transform after:duration-300 cursor-pointer"
                >
                  {item.name}
                </ScrollLink>
              ) : (
                <Link
                  key={item.to}
                  to={item.to}
                  className={`px-4 py-2 text-sm font-medium rounded-lg transition-all duration-300
                                              hover:bg-gray-100 relative after:absolute after:bottom-0 after:left-0
                                              after:w-full after:h-0.5 after:bg-red-600 after:scale-x-0
                                              hover:after:scale-x-100 after:transition-transform after:duration-300 cursor-pointer
                                              ${
                                                location.pathname === item.to
                                                  ? "text-red-600 bg-red-50"
                                                  : "text-gray-700 hover:text-red-600"
                                              }`}
                >
                  {item.name}
                </Link>
              )
            )}
          </nav>

          {/* Actions - Desktop */}
          <div className="hidden md:flex items-center space-x-4">
            {/* Sélecteur de langue */}
            <div className="relative" ref={langMenuRef}>
              <button
                onClick={() => setShowLangMenu(!showLangMenu)}
                className="flex items-center space-x-2 p-2 rounded-lg hover:bg-gray-100
                                         transition-colors duration-300"
              >
                <img
                  src={Logofrance}
                  alt="Current language"
                  className="w-6 h-6 rounded-full"
                />
                <KeyboardArrowDownIcon
                  className={`transform transition-transform duration-300
                                    ${showLangMenu ? "rotate-180" : ""}`}
                />
              </button>
              {showLangMenu && (
                <div
                  className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg
                                              transform origin-top-right transition-all duration-300"
                >
                  {languages.map((lang) => (
                    <button
                      key={lang.code}
                      className="flex items-center space-x-3 w-full px-4 py-3 text-sm
                                                     text-gray-700 hover:bg-gray-50 transition-colors duration-300"
                    >
                      <img
                        src={lang.flag}
                        alt={lang.name}
                        className="w-6 h-6 rounded-full"
                      />
                      <span>{lang.name}</span>
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Menu mobile */}
          <button
            className="md:hidden p-2 rounded-lg text-gray-500 hover:text-red-600
                                 hover:bg-gray-100 transition-all duration-300"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <CloseIcon /> : <MenuIcon />}
          </button>
        </div>

        {/* Menu mobile déroulant */}
        <div
          className={`md:hidden overflow-hidden transition-all duration-300 ease-in-out
                               ${isMenuOpen ? "max-h-96" : "max-h-0"}`}
          ref={menuRef}
        >
          <nav className="py-3 space-y-1">
            {navItems.map((item) =>
              isHome ? (
                <ScrollLink
                  key={item.to}
                  to={item.to}
                  spy={true}
                  smooth={true}
                  duration={500}
                  onClick={() => setIsMenuOpen(false)}
                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50
                                             hover:text-red-600 transition-colors duration-300"
                >
                  {item.name}
                </ScrollLink>
              ) : (
                <Link
                  key={item.to}
                  to={item.to}
                  onClick={() => setIsMenuOpen(false)}
                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50
                                             hover:text-red-600 transition-colors duration-300"
                >
                  {item.name}
                </Link>
              )
            )}
          </nav>
        </div>
      </div>
      <ScrollToTop />
    </header>
  );
}

export default Header;
